import { defineMessages, IntlShape } from "react-intl";

import CumulShareType from "@mapmycustomers/shared/enum/cumul/CumulShareType";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<CumulShareType>({
  [CumulShareType.ORG]: {
    id: "cumulShareType.org",
    defaultMessage: "Entire Org",
  },
  [CumulShareType.TEAM]: {
    id: "cumulShareType.team",
    defaultMessage: "Team",
  },
  [CumulShareType.USER]: {
    id: "cumulShareType.user",
    defaultMessage: "User",
  },
});

const getCumulShareTypeDisplayName = (intl: IntlShape, shareType: CumulShareType) =>
  getDisplayName(intl, messages, shareType, "CumulShareType");

export default getCumulShareTypeDisplayName;
